import logo from "./Logo.svg";

export const Images = {
  logo,
};
